import * as React from 'react';
import {connect} from 'react-redux';
import {Router as ReactRouter, Route, Redirect, browserHistory} from 'react-router';

import {URL_PREFIX} from "../const/forms";
import {getForms} from '../actions';


import FormPage from '../containers/FormPage';
import MainPage from '../containers/MainPage';
import Auth from "../containers/Auth";

export const history = browserHistory;

const Router = () => (
    <Auth>
        <ReactRouter history={history}>
            <Redirect from='/' to={URL_PREFIX + '/'}/>
            <Route exact path={URL_PREFIX + '/forms/:form_type/:process_id'} component={FormPage}/>
            {/* <Route exact path={URL_PREFIX + /company'} component={SelectCompany}/> */}
            <Route exact path={URL_PREFIX + '/'} component={MainPage}/>
            <Route exact path={URL_PREFIX + '/404'} component={() => <p>ERROR 404: Route not found</p>}/>
            <Redirect from="*" to={URL_PREFIX + "/404"}/>
        </ReactRouter>
    </Auth>
)

const mapStateToProps = (state, ownProps) => ({
  // schema: state.forms,
  // loaders: state.forms.loaders,
})

const mapDispatchToProps = (dispatch) => ({
    // setSection: (id: string) => dispatch(setSection(id)),
    // addValue: (id: string, value: any, refresh: boolean) => dispatch(addValue(id, value, refresh)),
    // addFile: (id: string, filename: string) => dispatch(addFile(id, filename)),
    // checkedPanel: (panelId: string, checked: boolean, error: IControlError | undefined) => dispatch(checkedPanel(panelId, checked, error)),
    // incrimentToSend: () => dispatch(incrimentToSend()),
    // loadFrom: (form_type: string, process_id: number) => dispatch(loadFrom(form_type, process_id)),
    // copyValue: (sourceId: string, targetId: string) => dispatch(copyValue(sourceId, targetId)),
    // recal: () => dispatch(recal()),
    // markVisited: (id: string) => dispatch(markVisited(id)),
    // setError: (id: string, error: IControlError) => dispatch(setError(id, error)),
    // markAllVisited: () => dispatch(markAllVisited()),
    getForms: () => dispatch(getForms()),
    // getTags: () => dispatch(getTags()),
})

export default connect(mapStateToProps,mapDispatchToProps)(Router);
